import { useState } from "react";
import { sendContactMessage } from "../services/contactService";

function ContactForm() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation (trim safe)
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setStatus("Please fill all fields");
      return;
    }

    try {
      setLoading(true);
      setStatus("");

      await sendContactMessage({
        name: form.name.trim(),
        email: form.email.trim(),
        message: form.message.trim()
      });

      // Success
      setStatus("Message sent successfully ✅");

      // Reset form
      setForm({
        name: "",
        email: "",
        message: ""
      });

      // Auto-hide message
      setTimeout(() => setStatus(""), 3000);

    } catch (error) {
      console.error("Contact error:", error);

      setStatus(
        error?.response?.data?.msg || "Server error. Try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-container" id="contact">
      <h2 className="contact-title">Contact Us</h2>

      <form className="contact-form" onSubmit={handleSubmit}>
        
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Enter your name"
            className="form-input"
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Enter your email"
            className="form-input"
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label>Message</label>
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Write your message..."
            className="form-textarea"
            rows="4"
            disabled={loading}
          />
        </div>

        <button
          type="submit"
          className="contact-btn"
          disabled={loading}
        >
          {loading ? "Sending..." : "Send Message"}
        </button>

        {status && (
          <p className={`form-status ${status.includes("success") ? "success" : "error"}`}>
            {status}
          </p>
        )}
      </form>
    </div>
  );
}

export default ContactForm;